var _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _polygon2, _rect, _style, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoat = function SvgBoat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 2677 1772"
    },
    id: "Layer_1",
    viewBox: "0 0 2677 1772",
    x: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    y: "0px",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1281.74,
    x2: 1281.74,
    y1: 45.2,
    y2: 1374.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1319.56,238.3c0,0,655.29,304.57,778.74,1011.63c-409.02,12.47-475.71-189.72-779.75,38.68 C1531.8,555.37,1319.56,238.3,1319.56,238.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1246.57,307.31c0,0-119.27,380.13-7.04,988.05c-306.77-63.6-666.37,79.31-666.37,79.31 S793.93,806,1246.57,307.31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1147.24,1632.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1264.76,1632.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1264.76,1632.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1422.98,1632.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M451.23,1437.48c458.64,335.38,688.35,249.4,847.97,72.33c214.49,104.75,448.93,144.65,680.87-42.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1095.92,1721.55c113.15-25.98,170.57-87.07,219.97-138.37c35.37,18.74,114.36,57.9,217.45,74.53"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.52,1671.15c114.93-16.38,177.28-72.44,230.81-119.4c33.67,21.65,109.1,67.3,210.42,92.53"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M451.23,1437.48l1780.74-134.68c0,0-232.64,383.3-565.83,365.05"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1921.35,1663.34c111.7-31.64,165.97-95.54,212.73-149.26c36.27,16.94,117.13,52.08,220.92,63.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1281.74,86.18 749.92,209.36 652.39,295.55 1283.14,246.71 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1275.5,245.72 749.92,209.36 640.02,128.45 1281.74,86.18 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 82.11,
    transform: "matrix(0.997 -0.0772 0.0772 0.997 -11.9061 79.2327)",
    width: 477.67,
    x: 779.93,
    y: 152.54
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#35B9CC;}\n\t.st1{fill:none;stroke:#000000;stroke-width:11.1712;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#D1366A;}\n\t.st3{fill:none;stroke:#35B9CC;stroke-width:17.8739;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-width:17.8739;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{font-family:'MarkerFelt-Wide';}\n\t.st8{font-size:71.4451px;}\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st6 st7 st8",
    transform: "matrix(0.997 -0.0772 0.0772 0.997 782.0324 229.9433)"
  }, "TECH ANCHOR")));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boat.1dfff91885340e45a12de251b1ae555c.svg";